import { trackPromise } from "react-promise-tracker";
import useProviders from "../../providers";

const useRolesServices = () => {
  const { useRolesProvider } = useProviders();
  const {
    listRolesProvider,
    addRoleProvider,
    editRoleProvider,
    deleteRoleProvider,
    getRoleByIdProvider,
  } = useRolesProvider();

  const listRolesService = ({ page, search }) => {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await trackPromise(listRolesProvider({ page, search })));
      } catch (error) {
        reject(error);
      }
    });
  };

  const addRoleService = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await trackPromise(addRoleProvider(data)));
      } catch (error) {
        reject(error);
      }
    });
  };

  const editRoleService = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await trackPromise(editRoleProvider(id, data)));
      } catch (error) {
        reject(error);
      }
    });
  };

  const deleteRoleService = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await trackPromise(deleteRoleProvider(id)));
      } catch (error) {
        reject(error);
      }
    });
  };

  const getRoleByIdService = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(await trackPromise(getRoleByIdProvider(id)));
      } catch (error) {
        reject(error);
      }
    });
  };

  return {
    listRolesService,
    addRoleService,
    editRoleService,
    deleteRoleService,
    getRoleByIdService,
  };
};

export default useRolesServices;
